/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React, { useState, useEffect, Fragment } from 'react';
import { MaskedTextField, PrimaryButton, Spinner, SpinnerSize } from '@fluentui/react';
import { TextField } from '@fluentui/react';
import { AUTH_CONFIG } from './auth0-variables';
import axios from 'axios';
import TwoSidedLayout from '../components/TwoSidedLayout';
import { useHistory, Link } from "react-router-dom";
import { WarningFilled } from "@fluentui/react-icons";
import Lottie from 'lottie-react-web'
import animation from './animation.json'
import { isMobile } from "react-device-detect";

const error = (e) => css`
  .ms-TextField-fieldGroup { border-color: ${e ? '#ff1f1f' : '#D5DBE4'}; }
  .ms-TextField-errorMessage{ color:#ff1f1f; padding-top: 0; }
`;

const warning = () => css`
  display: flex; align-items: flex-start; background: rgb(254, 247, 225);
  border: 1px solid transparent; border-radius: 8px; padding: 12px 12px 12px 20px;
  max-width: 100%; width: 100%;
  font-family: "proxima-nova", "Arial CE", Arial, sans-serif;
  svg{ font-size: 20px; color: rgb(214, 156, 0); }
  p{ line-height: 18px; margin: 0; font-size: 13px; color: rgb(48, 54, 60); }
`;
const lottie = () => css`
  display: flex; align-items: center; justify-content: center;
  width: 100%; height: 120px; margin-top: 20px;
`;

function ActivateAccount(props) {
    const [password, setPassword] = useState('');
    const [passwordError, setPasswordError] = useState(undefined);
    const [confirmPassword, setConfirmPassword] = useState();
    const [confirmPasswordError, setConfirmPasswordError] = useState(undefined);
    const [showSuccess, setShowSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState('');
    const [userId, setUserId] = useState();
    const [phoneError, setPhoneError] = useState(undefined);
    const [firstName, setFirstname] = useState('');
    const [lastName, setLastname] = useState('');
    const [firstNameError, setFirstnameError] = useState(undefined);
    const [lastNameError, setLastnameError] = useState(undefined);
    const [codeExpired, setCodeExpired] = useState(undefined);

    const history = useHistory();
    const queryParams = new URLSearchParams(window.location.search)
    const token = queryParams.get("token")
    const email = queryParams.get("email")

    useEffect(() => {
        const model = { Email: email, Token: token };
        axios.post(AUTH_CONFIG.API_URL + "/api/auth/ActivateAccountInit", model)
            .then((response) => {
                debugger;
                if (response.data === "code-expired") {
                    setCodeExpired(true)
                } else {
                    setFirstname(response.data.firstName);
                    setLastname(response.data.lastName);
                    setPhoneNumber(response.data.phoneNumber || '');
                    setUserId(response.data.id);
                }
            });
    }, [email, token]);

    const handleSubmit = (event) => {
        let hasErrors = false;
        event.preventDefault();

        if (!firstName) { setFirstnameError("First Name Required"); hasErrors = true; }
        if (!lastName) { setLastnameError("Last Name Required"); hasErrors = true; }
        if (!password) { setPasswordError("Password Required"); hasErrors = true; }

        if (!password_validate()) {
            hasErrors = true;
            setPasswordError('Please create a password with at least 8 characters, one lower case letter, one number and one special character.')
        }

        if (password.length < 6) {
            setPasswordError("Please create a password that's just a bit longer (at least 6 characters).");
            hasErrors = true;
        }
        if (password !== confirmPassword) {
            setConfirmPasswordError("Passwords do not match!");
            hasErrors = true;
        }
        if (!confirmPassword) {
            setConfirmPasswordError("Please confirm password");
            hasErrors = true;
        }

        if (hasErrors) return;

        const qp = new URLSearchParams(window.location.search)
        const t = qp.get("token")
        const em = qp.get("email")

        const model = {
            FirstName: firstName,
            LastName: lastName,
            Password: password,
            PhoneNumber: phoneNumber ? phoneNumber.replace(/[\W_]/g, '') : null,
            Email: em,
            Token: t
        }
        axios.post(AUTH_CONFIG.API_URL + "/api/auth/ActivateAccount", model)
            .then(() => setShowSuccess(true))
            .catch((err) => {
                if (err?.response?.data === "PasswordStrengthError: Password is too weak") {
                    setPasswordError("Password is too weak");
                }
            });
    }

    const handlePasswordChange = (event) => { setPassword(event.target.value); setPasswordError(undefined) };
    const handleConfirmPasswordChange = (event) => { setConfirmPassword(event.target.value); setConfirmPasswordError(undefined) };

    const password_validate = () => {
        var re = {
            capital: /(?=.*[A-Z])/,
            length: /(?=.{7,40}$)/,
            specialChar: /[ -\/:-@\[-\`{-~]/,
            digit: /(?=.*[0-9])/,
        };
        return re.capital.test(password) && re.length.test(password) && re.specialChar.test(password) && re.digit.test(password);
    };

    const handlePhoneNumberChange = (event) => setPhoneNumber(event.target.value);
    const handleFirstnameChange = (event) => { setFirstname(event.target.value); setFirstnameError(undefined) };
    const handleLastnameChange = (event) => { setLastname(event.target.value); setLastnameError(undefined) };

    return (
        <TwoSidedLayout width={450}>
            <div className="height100 flexcolumn width100 justifycenter" style={{ maxWidth: '452px', margin: 'auto' }}>
                {!showSuccess && <>
                    <h2 className="head-30 mb10">Activate your account</h2>
                    <p className="mb15" style={{ color: '#68707b' }}>Hello {firstName}, please fill out the form to activate your account.</p>

                    {codeExpired && <div className="my10" css={warning}>
                        <div className="mr15"><WarningFilled /></div>
                        <div className="displayflex flexcolumn">
                            <h5 className="head-xs mb5">Link Expired!</h5>
                            <p className="label-large">Your link has expired, please contact your manager to get a new link.</p>
                        </div>
                    </div>}

                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <div className="m-b-5" css={error(false)}>
                                <TextField
                                    fullWidth
                                    id="email"
                                    label="Username"
                                    disabled
                                    value={email}
                                    styles={{ fieldGroup: { height: '44px' }, field: { height: '42px' } }}
                                />
                            </div>

                            <div className="m-b-5 displayflex" css={error(firstNameError + lastNameError)}>
                                <TextField
                                    errorMessage={firstNameError}
                                    id="firstName"
                                    label="First Name"
                                    className="mr10 flex1"
                                    styles={{ fieldGroup: { height: '44px' }, field: { height: '42px' } }}
                                    value={firstName}
                                    onChange={handleFirstnameChange}
                                />
                                <TextField
                                    styles={{ fieldGroup: { height: '44px' }, field: { height: '42px' } }}
                                    errorMessage={lastNameError}
                                    id="lastName"
                                    className=" flex1"
                                    label="Last Name"
                                    value={lastName}
                                    onChange={handleLastnameChange}
                                />
                            </div>

                            <div className="mb10" css={error(passwordError)}>
                                <TextField
                                    styles={{ fieldGroup: { height: '44px' }, field: { height: '42px' } }}
                                    errorMessage={passwordError}
                                    id="password"
                                    label="Password"
                                    type="password"
                                    value={password}
                                    canRevealPassword
                                    onChange={handlePasswordChange}
                                    onBlur={() => {
                                        if (!password_validate()) {
                                            setPasswordError('Please create a password with at least 8 characters, one lower case letter, one number and one special character.')
                                        }
                                    }}
                                />
                            </div>

                            <p className="secondary-small mb20" style={{ color: '#818b95' }}>
                                Your password must contain at least 8 characters, one lower case letter, one number and one special character.
                            </p>

                            <div className="mb10" css={error(confirmPasswordError)}>
                                <TextField
                                    styles={{ fieldGroup: { height: '44px' }, field: { height: '42px' } }}
                                    errorMessage={confirmPasswordError}
                                    id="confirmPassword"
                                    label="Confirm new password"
                                    type="password"
                                    value={confirmPassword}
                                    canRevealPassword
                                    onChange={handleConfirmPasswordChange}
                                />
                            </div>

                            <div className="mb10" css={error(false)}>
                                <MaskedTextField
                                    styles={{ fieldGroup: { height: '44px' }, field: { height: '42px', color: phoneNumber ? 'var(--fui-neutralPrimary)' : 'rgb(161 170 179)' } }}
                                    id="phoneNumber"
                                    placeholder="(240) 507 0895"
                                    errorMessage={phoneError}
                                    label="Phone Number"
                                    value={phoneNumber}
                                    onChange={handlePhoneNumberChange}
                                    onBlur={() => {
                                        axios.get(AUTH_CONFIG.API_URL + "/api/Account/PhoneAvailableCheckWithCurrentUser?phonenumber=" + phoneNumber + '&userId=' + userId)
                                            .then((response) => {
                                                if (response.data == 1) {
                                                    setPhoneError('Phone number is already in use.')
                                                } else {
                                                    setPhoneError(undefined)
                                                }
                                            });
                                    }}
                                    mask="(999) 999-9999"
                                />
                            </div>

                            <div>
                                <PrimaryButton
                                    text={!loading ? "Activate account" : <Spinner size={SpinnerSize.small} />}
                                    disabled={!password_validate() || (password !== confirmPassword) || (!password) || phoneError}
                                    onClick={handleSubmit}
                                    style={{ width: '100%' }}
                                    className="mt10 continue"
                                />
                            </div>
                        </div>
                    </form>
                </>}

                {showSuccess && <div className="flexcolumn aligncenter justifycenter">
                    <div css={lottie}>
                        <Lottie options={{ animationData: animation, loop: false }} />
                    </div>
                    <h2 className="head-30 mt20">Account activated!</h2>
                    <p className="mb35 mt5" style={{ color: '#68707b' }}>Your account has been successfully activated.</p>

                    {/* MOBILE-ONLY: show mobile download block */}
                    {isMobile && (
                        <div className="flexcolumn justifycenter show-mobile">
                            <h1 className="head-m" style={{ fontSize: 18 }}>Download our mobile app</h1>
                            <div className="flexcolumn justifycenter">
                                <a href="https://apps.apple.com/us/app/teamsly/id6575352008?platform=iphone">
                                    <img style={{ height: 50 }} src="https://cdn.prod.website-files.com/66b58823c7015d385cecf0bd/66f4939584a817e010a2d5e7_app-store-small.avif" loading="lazy" alt="" />
                                </a>
                                <a href="https://play.google.com/store/apps/details?id=com.teamsly.teamsly&hl=en_US">
                                    <img style={{ height: 50 }} src="https://cdn.prod.website-files.com/66b58823c7015d385cecf0bd/66f4943bb9181e7e43b3fa5b_google-play-small.avif" loading="lazy" alt="" />
                                </a>
                            </div>
                        </div>
                    )}

                    {/* DESKTOP/TABLET-ONLY: show Log in button */}
                    {!isMobile && (
                        <PrimaryButton
                            text={"Log in"}
                            onClick={() => history.push('/login')}
                            style={{ width: '100%' }}
                            className="mt10 continue"
                        />
                    )}
                </div>}
            </div>
            <div style={{ padding: isMobile ? '24px 0px 40px 0px' : '24px 0px 8% 0px' }}>
                <div className="flexcolumn aligncenter mt20">
                    <p className="d-p">By proceeding, you agree to the</p>
                    <div className="displayflex justifycenter">
                        <a id="" href="https://www.teamslyapp.com/terms" rel="noreferrer" target="_blank">
                            <span className="d-p">Terms of Service</span>
                        </a>
                        <div class="mx5"> and </div>
                        <a id="" href="https://www.teamslyapp.com/privacy-policy" rel="noreferrer" target="_blank" >
                            <span className="d-p">Privacy Policy</span>
                        </a>
                    </div>
                </div>
            </div>
        </TwoSidedLayout>
    );
}

export default ActivateAccount;
